import CatalogGallery from '@/components/catalog/gallery';
import { Carousel, Slide } from 'vue-carousel';
import qtyInput from '@/components/qty';
import SectionSlider from '@/components/section-slider';

export default {
    CatalogGallery,
    Carousel,
    SectionSlider,
    Slide,
    qtyInput,
};
